import type { ComponentType, SVGProps } from 'react'
import {
  IconBanknote,
  IconBuilding2,
  IconCreditCard,
  IconLayoutDashboard,
  IconMail,
  IconSettings,
} from '../components/icons'

export type SidebarNavItem = {
  to: string
  label: string
  end?: boolean
  icon: ComponentType<SVGProps<SVGSVGElement>>
  /** Hidden unless operator has ALL platform scope */
  allScopeOnly?: boolean
}

export type SidebarNavSegment = {
  title?: string
  items: SidebarNavItem[]
}

export const platformSidebarNav: SidebarNavSegment[] = [
  {
    items: [
      {
        to: '/',
        label: 'Dashboard',
        end: true,
        icon: IconLayoutDashboard,
      },
    ],
  },
  {
    title: 'Platform',
    items: [
      {
        to: '/organizations',
        label: 'Organizations',
        end: false,
        icon: IconBuilding2,
      },
    ],
  },
  {
    title: 'Payments & finance',
    items: [
      {
        to: '/payment-gateways',
        label: 'Payment methods',
        end: true,
        icon: IconCreditCard,
        allScopeOnly: true,
      },
      {
        to: '/withdrawals',
        label: 'Withdrawals',
        end: true,
        icon: IconBanknote,
      },
    ],
  },
  {
    title: 'Content & legal',
    items: [
      {
        to: '/newsletters',
        label: 'Newsletter',
        end: true,
        icon: IconMail,
      },
      {
        to: '/contact-messages',
        label: 'Contact messages',
        end: true,
        icon: IconMail,
        allScopeOnly: true,
      },
      {
        to: '/legal/imprint',
        label: 'Imprint',
        end: true,
        icon: IconSettings,
        allScopeOnly: true,
      },
      {
        to: '/legal/pricing',
        label: 'Pricing',
        end: true,
        icon: IconSettings,
        allScopeOnly: true,
      },
    ],
  },
  {
    title: 'Settings',
    items: [
      {
        to: '/platform/team',
        label: 'Platform team',
        end: true,
        icon: IconSettings,
        allScopeOnly: true,
      },
      {
        to: '/settings',
        label: 'General',
        end: true,
        icon: IconSettings,
      },
    ],
  },
]
